export default "__VITE_ASSET__UqgWuU74pwaSiWGhKsk0qw__"